var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._m(1),_c('navigation'),_c('ftu'),_c('router-view'),_c('the-foot')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"bg"},[_c('li',[_c('span')])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"skip"}},[_c('a',{attrs:{"href":"#main"}},[_vm._v("Skip Navigation Links")])])
}]

export { render, staticRenderFns }